import axios from "axios";
import { useEffect, useState } from "react";
import { URL_API } from "../../utils/helper/helpers";
import { toast } from "react-toastify";

interface FacturesInterfaces {
    [key: string]: any;
}

const useFacturesListe = (refresh: boolean): FacturesInterfaces[] => {
    const [factures, setFactures] = useState<FacturesInterfaces[]>([]);
    const Token = JSON.parse(localStorage.getItem("login")!);

    useEffect(() => {
        const fetchFactures = async () => {
            axios.get(`${URL_API}/factures/index`, {
                headers: {
                    Authorization: `Bearer ${Token}`
                }
            }).then(response => {

                if (response.status === 200) {
                    setFactures(response.data.factures);
                }

            }).catch(error => {

                if (error.response.status === 404) {
                    toast.info(error.response.data.message);
                }
            })
        };

        fetchFactures();
    }, [refresh]);
    return factures;
};
export default useFacturesListe;

export const deleteFactures = async ({ id }: { id: number }, onSuccess: () => void) => {
    const Token = JSON.parse(localStorage.getItem("login")!);

    axios.post(`${URL_API}/factures/destroy/${id}`, {}, {
        headers: {
            Authorization: `Bearer ${Token}`
        }
    }).then(response => {

        if (response.data.status) {
            toast.warning(response.data.message)
            onSuccess();
        }

    }).catch(error => {
        if (error.response.status === 404) {
            toast.info(error.response.data.message)
        }
        if (error.response.status === 500) {
            toast.info(error.response.data.message)
        }
    })

}



interface RecuInterfaces {
    [key: string]: any;
}

export const useRecuListe = (refresh: boolean): RecuInterfaces[] => {
    const [recu, setRecu] = useState<RecuInterfaces[]>([]);
    const Token = JSON.parse(localStorage.getItem("login")!);

    useEffect(() => {
        const fetchRecu = async () => {
            axios.get(`${URL_API}/recu/index`, {
                headers: {
                    Authorization: `Bearer ${Token}`
                }
            }).then(response => {

                if (response.status === 200) {
                    setRecu(response.data.recu);
                }

            }).catch(error => {

                if (error.response.status === 404) {
                    toast.info(error.response.data.message);
                }
            })
        };

        fetchRecu();
    }, [refresh]);
    return recu;
};

export const deleteRecu = async ({ id }: { id: number }, onSuccess: () => void) => {
    const Token = JSON.parse(localStorage.getItem("login")!);

    axios.post(`${URL_API}/recu/destroy/${id}`, {}, {
        headers: {
            Authorization: `Bearer ${Token}`
        }
    }).then(response => {

        if (response.data.status) {
            toast.warning(response.data.message)
            onSuccess();
        }

    }).catch(error => {
        if (error.response.status === 404) {
            toast.info(error.response.data.message)
        }
        if (error.response.status === 500) {
            toast.info(error.response.data.message)
        }
    })

}